module.exports = __webpack_public_path__ + "static/media/nimblr.f9641e4a.svg";